import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MasterSlaApiResponse } from '../types/api/MasterSlaApiType';

// 保守レベルのマスタ管理
const slice = createSlice({
    name: 'MasterSlaData',
    // 初期値
    initialState: [] as Array<MasterSlaApiResponse>,
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<Array<MasterSlaApiResponse>>) => action.payload,
        // 初期化
        initState: () => [],
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
